module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modifiers"
  }, [_c('b-form-fieldset', [_c('legend', [_vm._v("Character")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Initial dice pool",
      "description": "Usually AGI + weapon skill."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.dicePool),
      callback: function($$v) {
        _vm.userData.dicePool = $$v
      },
      expression: "userData.dicePool"
    }
  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Condition monitor penalty"
    }
  }, [_c('b-input-group', {
    attrs: {
      "left": "-"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.conditionPenalty),
      callback: function($$v) {
        _vm.userData.conditionPenalty = $$v
      },
      expression: "userData.conditionPenalty"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Strength"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.strength),
      callback: function($$v) {
        _vm.userData.strength = $$v
      },
      expression: "userData.strength"
    }
  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Willpower"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    on: {
      "change": _vm.limitTakeAim
    },
    model: {
      value: (_vm.userData.willpower),
      callback: function($$v) {
        _vm.userData.willpower = $$v
      },
      expression: "userData.willpower"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', [_c('legend', [_vm._v("Gear")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Weapon type"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.staticData.weaponTypeOptions
    },
    model: {
      value: (_vm.userData.weaponType),
      callback: function($$v) {
        _vm.userData.weaponType = $$v
      },
      expression: "userData.weaponType"
    }
  })], 1)], 1), _vm._v(" "), (_vm.weaponHasRecoil) ? _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Total recoil compensation",
      "description": "The total for all weapons you're firing this Action Phase."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.recoilCompensation),
      callback: function($$v) {
        _vm.userData.recoilCompensation = $$v
      },
      expression: "userData.recoilCompensation"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('setting-col', [(_vm.showWeaponRating) ? _c('b-form-group', {
    attrs: {
      "label": "Weapon rating"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.weaponRatingFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.weaponRating),
      callback: function($$v) {
        _vm.userData.weaponRating = $$v
      },
      expression: "userData.weaponRating"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showIgnoreMinRange) ? _c('div', [_c('b-form-checkbox', {
    model: {
      value: (_vm.userData.ignoreMinRange),
      callback: function($$v) {
        _vm.userData.ignoreMinRange = $$v
      },
      expression: "userData.ignoreMinRange"
    }
  }, [_vm._v("\n        Ignore minimum range\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Environmental compensation"
    }
  }, _vm._l((_vm.sortedCompensationTypes), function(pair) {
    return _c('b-form-checkbox', {
      key: pair.key,
      model: {
        value: (_vm.userData.gear[pair.key]),
        callback: function($$v) {
          _vm.$set(_vm.userData.gear, pair.key, $$v)
        },
        expression: "userData.gear[pair.key]"
      }
    }, [_vm._v("\n        " + _vm._s(pair.value) + "\n      ")])
  }))], 1), _vm._v(" "), _c('b-form-fieldset', [_c('legend', [_vm._v("Environment")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Visibility"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.staticData.visibilityOptions
    },
    model: {
      value: (_vm.userData.visibility),
      callback: function($$v) {
        _vm.userData.visibility = $$v
      },
      expression: "userData.visibility"
    }
  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Light"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.staticData.lightOptions
    },
    model: {
      value: (_vm.userData.light),
      callback: function($$v) {
        _vm.userData.light = $$v
      },
      expression: "userData.light"
    }
  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Glare"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.staticData.glareOptions
    },
    model: {
      value: (_vm.userData.glare),
      callback: function($$v) {
        _vm.userData.glare = $$v
      },
      expression: "userData.glare"
    }
  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Wind"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.staticData.windOptions
    },
    model: {
      value: (_vm.userData.wind),
      callback: function($$v) {
        _vm.userData.wind = $$v
      },
      expression: "userData.wind"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('b-form-fieldset', [_c('legend', [_vm._v("Situational")]), _vm._v(" "), _vm._l((_vm.sortedSitMods), function(pair) {
    return _c('b-form-checkbox', {
      key: pair.key,
      model: {
        value: (_vm.userData.rangedSitMods[pair.key]),
        callback: function($$v) {
          _vm.$set(_vm.userData.rangedSitMods, pair.key, $$v)
        },
        expression: "userData.rangedSitMods[pair.key]"
      }
    }, [_vm._v("\n      " + _vm._s(pair.value) + "\n    ")])
  }), _vm._v(" "), _c('b-form-radio-group', {
    attrs: {
      "options": _vm.staticData.rangedLOSOptions
    },
    model: {
      value: (_vm.userData.rangedLOS),
      callback: function($$v) {
        _vm.userData.rangedLOS = $$v
      },
      expression: "userData.rangedLOS"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Distance to target",
      "state": _vm.distanceValid,
      "description": _vm.distanceDescription
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "m"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "state": _vm.distanceValid,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.distance),
      callback: function($$v) {
        _vm.userData.distance = $$v
      },
      expression: "userData.distance"
    }
  })], 1), _vm._v(" "), (!_vm.distanceValid) ? _c('div', {
    staticClass: "error-feedback"
  }, [_vm._v("\n            Enter a valid distance.\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.weaponHasRecoil) ? _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Bullets fired",
      "description": "Include current action. Cumulative across Action Phases until an non-shooting action is taken. Ignore when firing a single weapon in Single Shot mode."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.bulletsFired),
      callback: function($$v) {
        _vm.userData.bulletsFired = $$v
      },
      expression: "userData.bulletsFired"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.hasWirelessProjectileBonus) ? _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Wireless projectile bonus",
      "description": "The number of wireless projectiles you've already thrown at your current target this Combat Turn (if your current projectile is also wireless)."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.zeroOrGreater,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.wirelessProjectileBonus),
      callback: function($$v) {
        _vm.userData.wirelessProjectileBonus = $$v
      },
      expression: "userData.wirelessProjectileBonus"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Take Aim bonus",
      "description": "Maximum WIL ÷ 2, rounded up."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.takeAimBonusFormatter,
      "lazy-formatter": ""
    },
    model: {
      value: (_vm.userData.takeAimBonus),
      callback: function($$v) {
        _vm.userData.takeAimBonus = $$v
      },
      expression: "userData.takeAimBonus"
    }
  })], 1)], 1), _vm._v(" "), _c('setting-col', [_c('b-form-group', {
    attrs: {
      "label": "Other modifiers",
      "description": "Use this for any modifiers not covered by other fields."
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.userData.otherModifiers),
      callback: function($$v) {
        _vm.userData.otherModifiers = $$v
      },
      expression: "userData.otherModifiers"
    }
  })], 1)], 1)], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-lg-3"
  }, [(_vm.allInputValid) ? _c('b-card', {
    staticClass: "text-center",
    attrs: {
      "bg-variant": "trans",
      "border-variant": "primary"
    }
  }, [_c('h3', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("Total dice pool: " + _vm._s(_vm.totalDicePoolString))])]) : _c('b-card', {
    staticClass: "text-center",
    attrs: {
      "bg-variant": "trans",
      "border-variant": "danger"
    }
  }, [_c('h3', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("No attack possible!")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-lg-6 offset-lg-3"
  }, [_c('div', {
    staticClass: "btn-group btn-group-justified",
    attrs: {
      "role": "group"
    }
  }, [_c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": "outline-warning",
      "size": "lg"
    },
    on: {
      "click": _vm.clearSituational
    }
  }, [_vm._v("\n            Clear situational\n          ")])], 1), _vm._v(" "), _c('b-button-group', [_c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "size": "lg"
    },
    on: {
      "click": _vm.clearUserData
    }
  }, [_vm._v("\n            Clear all\n          ")])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5d4bcb1d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modifiers/Modifiers.vue
// module id = 110
// module chunks = 2